import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13be5d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-primary" }, " Documentation ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, " PDF ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, " PDF ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, " PDF ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, " PDF ", -1))
const _hoisted_11 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_12 = { class: "badge badge-dark" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, " ZIP ", -1))
const _hoisted_14 = { class: "hash" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, " SHA256 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, " ZIP ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-info ml-2" }, " EXE ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, " PDF ", -1))
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "badge badge-dark" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, " ZIP ", -1))
const _hoisted_22 = { class: "col-8" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-nav-pills custom-nav-pills-s rounded mb-3 py-3 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-center w-100",
    pills: "",
    justified: ""
  }, " myCarto")
], -1))
const _hoisted_24 = { class: "ml-auto badge badge-dark" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "ml-auto badge badge-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card_header = _resolveComponent("b-card-header")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_b_card = _resolveComponent("b-card")!
  const _directive_b_toggle = _resolveDirective("b-toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.filesInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_b_list_group, null, {
                    default: _withCtx(() => [
                      (_ctx.filesInfo.documentation.preRequis)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 0,
                            button: "",
                            class: "d-flex align-items-center justify-content-between",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.preRequis)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("preRequisite")) + " ", 1),
                              _hoisted_7
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.filesInfo.documentation.breakingChanges)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 1,
                            button: "",
                            class: "d-flex align-items-center justify-content-between",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.breakingChanges)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("breakingChanges")) + " ", 1),
                              _hoisted_8
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.filesInfo.documentation.informationParVersion)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 2,
                            button: "",
                            class: "d-flex align-items-center justify-content-between",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.showFile(_ctx.filesInfo.documentation.informationParVersion)
                  ))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("importantInfo")) + " ", 1),
                              _hoisted_9
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.filesInfo.documentation.evolutionDoc)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 3,
                            button: "",
                            class: "d-flex align-items-center justify-content-between",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.showFile(_ctx.filesInfo.documentation.evolutionDoc)
                  ))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("evolution")) + " ", 1),
                              _hoisted_10
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                  })
                ]),
                ((_ctx.user.admin ||
                (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise')))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("install")) + " myCarto ", 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          (_ctx.filesInfo.installeur.zip)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 0,
                                button: "",
                                class: "d-flex align-items-center justify-content-between",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.installeur.zip.installer)))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("install")) + " myCarto", 1),
                                  _hoisted_13
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.installeur.zip)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 1,
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.filesInfo.installeur.zip.hash256), 1),
                                  _hoisted_15
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.installeur?.zip?.installMyCartoNavigationServer)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 2,
                                button: "",
                                class: "d-flex align-items-center justify-content-between",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.installeur.zip.installMyCartoNavigationServer)))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("installNav")), 1),
                                  _hoisted_16
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.installeur.exe)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 3,
                                button: "",
                                class: "d-flex align-items-center justify-content-between",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectToPage()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("runtime")) + " ", 1),
                                  _hoisted_17
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.installeur.doc)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 4,
                                button: "",
                                class: "d-flex align-items-center justify-content-between",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.installeur.doc)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("docInstall")) + " myCarto ", 1),
                                  _hoisted_18
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("mng")), 1),
                  _createVNode(_component_b_list_group, null, {
                    default: _withCtx(() => [
                      (_ctx.filesInfo.documentation.serverExpress)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 0,
                            button: "",
                            class: "d-flex align-items-center justify-content-between",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.serverExpress)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("serverExpress")) + " ", 1),
                              _hoisted_21
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.Patchnote.commentaire)
            ? (_openBlock(), _createBlock(_component_b_alert, {
                key: 0,
                variant: "warning",
                show: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Patchnote.commentaire), 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_23,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PatchnoteMode, (item, index) => {
              return (_openBlock(), _createBlock(_component_b_card, {
                key: index,
                "no-body": "",
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_card_header, {
                    "header-tag": "header",
                    class: "p-1",
                    role: "tab"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        class: "d-flex align-items-center",
                        href: "#",
                        show: "",
                        variant: "light"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.version) + " ", 1),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(item.date), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024)), [
                        [_directive_b_toggle, 'accordion-' + index]
                      ])
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_collapse, {
                    id: 'accordion-' + index,
                    visible: index == 0 ? true : false,
                    accordion: 'accordion-' + index,
                    role: "tabpanel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_card_body, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.historique, (type, typeIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: typeIndex }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type, (fix, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["ml-auto mb-1 p-2 rounded", 
                        typeIndex == 'correction' ? 'bg-light ' : 'bg-light'
                      ])
                                }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["mr-1 badge", 
                            typeIndex == 'correction'
                              ? 'badge-dark'
                              : 'badge-success'
                          ])
                                    }, _toDisplayString(typeIndex == "correction" ? "Ticket" : "Evol"), 3),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fix.ticket, (ticket, ticketIndex) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: ticketIndex,
                                        class: "mr-1 badge badge-primary"
                                      }, _toDisplayString(ticket), 1))
                                    }), 128)),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.date), 1)
                                  ]),
                                  (typeIndex == 'correction')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(fix.text), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(fix), 1)
                                      ], 64))
                                ], 2))
                              }), 128))
                            ]))
                          }), 128))
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["id", "visible", "accordion"])
                ], undefined, true),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}